import React, { useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import axios from 'axios';
import config from './../../../config';
import Swal from 'sweetalert2';
import '../../products/form/productForm.scss';   // styles des champs (.form-controle/.form-input)
import { NdoeActionButton } from '../../../components/ndoe';

/**
 * Filtre par plage de dates pour les détails de livraison.
 * Props : getProduits (setter data parent).
 */
const Livraison_detailSelect = ({ getProduits }) => {
  const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
  const [datas, setDatas] = useState({});

  const handleStartDateChange = (e) => setDatas((prev) => ({ ...prev, start_date: e.target.value }));
  const handleEndDateChange = (e) => setDatas((prev) => ({ ...prev, end_date: e.target.value }));

  const handleClick = async (e) => {
    e.preventDefault();
    if (!datas.start_date || !datas.end_date) {
      Swal.fire({ title: 'Error', text: 'Veuillez remplir tous les champs requis', icon: 'error', confirmButtonText: 'OK' });
      return;
    }
    try {
      const { data } = await axios.get(`${DOMAIN}/api/livraison/livraisonDetail?start_date=${datas.start_date}&end_date=${datas.end_date}`);
      // Normalise : l'endpoint renvoie { data, total } comme la liste paginée
      // (avant, on passait l'objet entier au parent, cassant le tableau).
      getProduits(Array.isArray(data) ? data : (data?.data ?? []));
    } catch (err) {
      Swal.fire({ title: 'Error', text: err.message, icon: 'error', confirmButtonText: 'OK' });
      console.log(err);
    }
  };

  return (
    <div className="ndoe-form-grid" style={{ alignItems: 'end' }}>
      <div className="form-controle">
        <label>Du</label>
        <input type="date" className="form-input" name="start_date" onChange={handleStartDateChange} />
      </div>
      <div className="form-controle">
        <label>Au</label>
        <input type="date" className="form-input" name="end_date" onChange={handleEndDateChange} />
      </div>
      <div className="ndoe-form-grid--full">
        <NdoeActionButton variant="ink" icon={<SearchOutlined />} onClick={handleClick}>
          Appliquer
        </NdoeActionButton>
      </div>
    </div>
  );
};

export default Livraison_detailSelect;
